<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h2>{{ $store.state.load.subTitle  }}</h2><h2 style="color:#EED202;" class="ml-3"> {{ " By " + ByDrill }}</h2> 
                <v-spacer></v-spacer>
                <v-btn dark icon :to="$store.state.load.return"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row justify="center">
                    <v-col cols="9">
                        
                <table 
                style="width: 100%;"
                dense
                    v-if="show == 1">
                    <thead>
                        <tr>
                            <template v-for="(head,index) in headers">
                                <th :key="index" :colspan="head.colspan">{{ head.text }}</th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(itm,index) in items">
                            <tr :key="index">
                                <td style="background: #fff;">{{ itm.ShiftDetail }}</td>
                                <td style="background: #fff;">{{ itm.Truck }}</td>
                                <td style="background: #fff;">{{ itm.DriverName }}</td>
                                <td style="background: #fff;">{{ itm.Trailer }}</td>
                                <td style="background: #fff;">{{ itm.Yard }}</td>
                            </tr>
                            <tr  :key="index">
                                    <th></th>
                                    <th>OrderID</th>
                                    <th>Customer</th>
                                    <th>TerminalName</th>
                                    <th>StationName</th>
                                    <th>Supplier</th>
                                    <th>OrderStatus</th>
                            </tr>
                            <template v-for="(ord,idx) in itm.orders">
                                <tr :key="idx">
                                    <td style="background: #ABC3C6;"></td>
                                    <td style="background: #ABC3C6;">{{ ord.OrderID }}</td>
                                    <td style="background: #ABC3C6;">{{ ord.Customer }}</td>
                                    <td style="background: #ABC3C6;">{{ ord.TerminalName }}</td>
                                    <td style="background: #ABC3C6;">{{ ord.StationName }}</td>
                                    <td style="background: #ABC3C6;">{{ ord.Supplier }}</td>
                                    <td style="background: #ABC3C6;">{{ ord.OrderStatus }}</td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
                <v-container style="height: 400px;" v-else>
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            Getting your files
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear
                                color="primary accent-4"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
export default {
    directives: { mask },
    data: function() {
        return {
            items: [],
            headers: [],
            search: '',
            show:0,
            colspan: 0,
            drillDown:'',
            ByDrill:'',
            Revenue: 0,
            OtherRev:0,
            Expenses:0,
            OtherExp:0,
            Net: 0,
        };
    },
    mounted() {
        console.log(this.$store.state.load.itm)
        switch (this.$store.state.load.title) {
            case 'Truck':
                this.headers = [
                    { text: 'ShiftDetail', value: 'ShiftDetail', colspan:'0' },
                    { text: 'Truck', value: 'Truck' },
                    { text: 'DriverName', value: 'DriverName', width: '8%' },
                    { text: 'Trailer', value: 'Trailer' },
                    { text: 'Yard', value: 'Yard' },
                ];
                this.ByDrill = this.$store.state.load.itm.Truck;
                this.drillDown = '/shift-load/transacting';
                break;
        }
        this.getItems();
    },
    methods: {
        getItems: function() {
            var parms = {
                StartDate: this.$store.state.load.StartTime,
                EndDate: this.$store.state.load.EndTime,
                Truck: this.$store.state.load.itm.TruckID,
                Driver: this.$store.state.load.itm.DriverID,
                Yard: this.$store.state.load.itm.YardId,
                Station: this.$store.state.load.itm.Station,
                Customer: this.$store.state.load.itm.CustGrpid,
                Terminal: this.$store.state.load.itm.TerminalID,
                Region: this.$store.state.load.itm.PrincipalRegionID,
            };
            console.log(parms);
            axios
                .post(this.$store.state.load.specific, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.items = response.data;
                    this.show = 1;
                })
                .catch(function(error) {
                    console.log(error);
                    this.show = 1;
                });
        },
        open: function(itm) {
            this.$store.state.load.subItem = itm;
            console.log(itm);
            this.$store.state.load.return = '/shift-load/specific';
            this.$router.push(this.drillDown);
        }
    }
};
</script>
<style>
.hover:hover {
    background: #a4a9de;
}
</style>
